// @ts-nocheck
import { post, deleteRequest } from './utils/api/index';
const API_URL = (process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768').trim();
const PUSH_SUBSCRIBE_URL = new URL('/api/v1/notificacoes/push/subscribe', API_URL).toString();
export const SW_PATH = '/push-sw.js';
export const obterEnvPushHabilitado = () => {
    return process.env.REACT_APP_NOTIFICACOES_PUSH === 'true';
};
export const obterVapidPublicKey = () => {
    const chave = (process.env.REACT_APP_VAPID_PUBLIC_KEY || '').trim();
    return chave.length > 0 ? chave : null;
};
export const suportaPush = () => {
    return (typeof navigator !== 'undefined' &&
        'serviceWorker' in navigator &&
        typeof window !== 'undefined' &&
        'PushManager' in window);
};
// Converte a VAPID public key (base64url) para o Uint8Array exigido por pushManager.subscribe.
export const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};
// Mapeia o JSON da PushSubscription do navegador para o contrato do SyncTransben.
export const montarSubscribePayload = (subscriptionJson) => {
    return {
        Endpoint: subscriptionJson?.endpoint || '',
        Keys: {
            P256dh: subscriptionJson?.keys?.p256dh || '',
            Auth: subscriptionJson?.keys?.auth || '',
        },
    };
};
const obterPermissaoNotification = () => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'denied';
    }
    return Notification.permission;
};
// Compara a applicationServerKey da subscription existente (ArrayBuffer) com a chave atual.
export const chavesVapidIguais = (chaveExistente, chaveAtual) => {
    if (!chaveExistente || !chaveAtual) {
        return false;
    }
    const a = new Uint8Array(chaveExistente);
    const b = new Uint8Array(chaveAtual);
    if (a.length !== b.length) {
        return false;
    }
    return a.every((valor, indice) => valor === b[indice]);
};
// Obtém a subscription reutilizável ou cria uma nova.
// Regras contra "AbortError: Registration failed - storage error" (Chrome):
// 1. subscription existente com a MESMA chave é reutilizada (sem novo subscribe);
// 2. subscription existente com chave DIFERENTE é descartada antes (subscribe com
//    outra applicationServerKey sobre subscription viva falha com storage error);
// 3. se subscribe falhar mesmo assim (estado corrompido no push service),
//    descarta o que existir e tenta UMA única vez de novo.
export const obterOuCriarSubscription = async (registration, applicationServerKey) => {
    const existente = await registration.pushManager.getSubscription();
    if (existente) {
        if (chavesVapidIguais(existente.options?.applicationServerKey, applicationServerKey)) {
            return existente;
        }
        await existente.unsubscribe();
    }
    const opcoes = { userVisibleOnly: true, applicationServerKey };
    try {
        return await registration.pushManager.subscribe(opcoes);
    }
    catch (erro) {
        console.warn('subscribe falhou; limpando subscription e tentando novamente:', erro);
        const residual = await registration.pushManager.getSubscription();
        if (residual) {
            await residual.unsubscribe();
        }
        return registration.pushManager.subscribe(opcoes);
    }
};
const executarInscricaoPush = async () => {
    if (!obterEnvPushHabilitado()) {
        return false;
    }
    if (!suportaPush()) {
        return false;
    }
    const vapidPublicKey = obterVapidPublicKey();
    if (!vapidPublicKey) {
        console.warn('REACT_APP_VAPID_PUBLIC_KEY ausente; push desabilitado.');
        return false;
    }
    if (obterPermissaoNotification() !== 'granted') {
        return false;
    }
    try {
        await navigator.serviceWorker.register(SW_PATH);
        // register() resolve com o SW ainda em "installing" e subscribe() exige SW ativo.
        // ready espera um SW ativo no escopo da página, imune a corridas de registro
        // e a workers substituídos durante a ativação (estado "redundant").
        const registration = await navigator.serviceWorker.ready;
        const subscription = await obterOuCriarSubscription(registration, urlBase64ToUint8Array(vapidPublicKey));
        const payload = montarSubscribePayload(subscription.toJSON());
        payload.UserAgent = typeof navigator.userAgent === 'string' ? navigator.userAgent : null;
        await post(PUSH_SUBSCRIBE_URL, payload);
        return true;
    }
    catch (erro) {
        console.warn('Falha ao inscrever push:', erro);
        return false;
    }
};
let inscricaoEmAndamento = null;
// Registra o SW, cria a subscription e envia ao backend.
// Nunca lança: degrada silenciosamente (SSE continua como canal principal).
// Chamadas concorrentes (gesto "Ativar alertas" + effect de reinscrição)
// compartilham a mesma promise para não registrar/postar em duplicidade.
export const inscreverPush = () => {
    if (!inscricaoEmAndamento) {
        inscricaoEmAndamento = executarInscricaoPush().finally(() => {
            inscricaoEmAndamento = null;
        });
    }
    return inscricaoEmAndamento;
};
// Remove a inscrição local e no backend. Nunca lança.
export const removerInscricaoPush = async () => {
    if (!suportaPush()) {
        return false;
    }
    try {
        const registration = await navigator.serviceWorker.getRegistration(SW_PATH);
        const subscription = await registration?.pushManager?.getSubscription();
        if (!subscription) {
            return false;
        }
        const endpoint = subscription.endpoint;
        await subscription.unsubscribe();
        await deleteRequest(PUSH_SUBSCRIBE_URL, { Endpoint: endpoint });
        return true;
    }
    catch (erro) {
        console.warn('Falha ao remover inscrição push:', erro);
        return false;
    }
};
